import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { AxiosResponse } from "axios";
import { CommentResource } from "../../../../stores/CommentStore/Types";
import { CurrentUser } from "../../../../stores/CurrentUserStore/Types";
import { postRequest, deleteRequest } from "../../../../utils/httpRequest";
import { errorNotification } from "../../../../utils/helpers";

interface Props {
  currentUser: CurrentUser;
  comment: CommentResource;
  updateComments: () => void;
}

interface State {
  liking: boolean;
  liked: boolean;
  likesCount: number;
  deleting: boolean;
}

class CommentReplies extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      liking: false,
      liked: false,
      likesCount: 0,
      deleting: false,
    };
  }

  componentDidMount() {
    const { currentUser, comment } = this.props;

    this.setState({
      liked: comment.liker_ids.includes(currentUser.id),
      likesCount: comment.likes_count,
    });
  }

  countryFlagImage = (countryCode) => {
    let img;
    try {
      img = require(
        `../../../../../../assets/images/flags/svg/${countryCode?.toLowerCase()}.svg`,
      );
    } catch {
      img = "";
    }

    return img;
  };

  likeComment = (e) => {
    e.preventDefault();
    this.setState({ liking: true });

    const { comment } = this.props;

    return postRequest(`/api/likes.json?comment_id=${comment.id}`, {})
      .then((response: AxiosResponse) => {
        this.setState({
          liking: false,
          liked: true,
          likesCount: this.state.likesCount + 1,
        });
      })
      .catch((error) => {
        this.setState({ liking: false });

        errorNotification(
          "Error liking comment",
          JSON.stringify(error.response.data),
        );
      });
  };

  unlikeComment = (e) => {
    e.preventDefault();

    const { comment } = this.props;

    return postRequest(`/api/likes/unlike.json?comment_id=${comment.id}`, {})
      .then((response: AxiosResponse) => {
        this.setState({
          liking: false,
          liked: false,
          likesCount: this.state.likesCount - 1,
        });
      })
      .catch((error) => {
        this.setState({ liking: false });

        errorNotification(
          "Error unliking comment",
          JSON.stringify(error.response.data),
        );
      });
  };

  deleteComment = (e) => {
    e.preventDefault();
    this.setState({ deleting: true });

    const { comment, updateComments } = this.props;

    const url = `/api/comments/${comment.id}.json?comment_id=${comment.id}`;

    return deleteRequest(url)
      .then((response: AxiosResponse) => {
        this.setState({ deleting: false });
        updateComments();
      })
      .catch((error) => {
        this.setState({ deleting: false });

        errorNotification(
          "Error deleting comment",
          JSON.stringify(error.response.data),
        );
      });
  };

  initials = () => {
    const { user } = this.props.comment;
    const name =
      user?.short_name_split || user?.short_name || user?.protected_name;

    return (
      name
        ?.split(" ")
        .map((part) => part[0])
        .join("")
        .slice(0, 2)
        .toUpperCase() || "42"
    );
  };

  render() {
    const {
      comment: { id, user, formatted_content, created_at, posted_on },
      currentUser,
    } = this.props;

    const { liking, liked, likesCount, deleting } = this.state;

    return (
      <div className="comment comment--reply conversation" id={`comment_${id}`}>
        {deleting && (
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Loading</div>
          </div>
        )}
        <span className="av-c">
          {user?.profile_picture_url || user?.profile_picture ? (
            <img
              src={user.profile_picture_url || user.profile_picture}
              alt=""
            />
          ) : (
            this.initials()
          )}
        </span>
        {/* The full date rides on the whole comment as a tooltip, so a rest of
            the mouse anywhere on it answers "when was this?" */}
        <div className="comment__body" title={posted_on}>
          <div className="comment__top">
            <span className="comment__name">{user?.protected_name}</span>
            {user?.country && (
              <img
                className="flag"
                src={this.countryFlagImage(user.country)}
                title={user.country_name}
                alt={user.country_name || user.country}
              />
            )}
            {created_at ? (
              <span className="comment__time">{created_at}</span>
            ) : (
              <span className="comment__time comment__time--on-hover">
                {posted_on}
              </span>
            )}
          </div>
          {/* @ts-ignore */}
          <div className="comment__text">
            {ReactHtmlParser(formatted_content)}
          </div>
          <div className="comment__actions">
            <button
              className={`${liking ? "loading" : ""} ${liked ? "liked" : ""}`}
              type="button"
              aria-pressed={liked}
              onClick={liked ? this.unlikeComment : this.likeComment}
            >
              <svg aria-hidden="true" viewBox="0 0 24 24">
                <path d="M12 21C7 16.5 3 13 3 8.6 3 5.9 5.2 4 7.5 4 9.5 4 11 5.3 12 7 13 5.3 14.5 4 16.5 4 18.8 4 21 5.9 21 8.6 21 13 17 16.5 12 21Z" />
              </svg>
              {likesCount}
            </button>
            {(user?.id === currentUser?.id || currentUser?.admin) && (
              <button type="button" onClick={this.deleteComment}>
                Delete
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default CommentReplies;
